import { cn } from '../ui/utils';

type PagePreloaderProps = {
    active?: boolean;
    fullScreen?: boolean;
    /** Modo suave (filtros / soft visit) — só barra, sem spinner. */
    soft?: boolean;
    /** Spinner centralizado na área de conteúdo (fase preload). */
    spinner?: boolean;
};

/**
 * Indicador de pré-carregamento no stage do main (não cobre sidebar/header).
 * Hard nav: barra + spinner central. Soft visit: só barra discreta.
 */
export default function PagePreloader({
    active = true,
    fullScreen = true,
    soft = false,
    spinner = true,
}: PagePreloaderProps) {
    const showSpinner = Boolean(active && spinner && !soft);

    const preloader = (
        <div
            className={cn(
                'nx-page-preloader',
                active && 'nx-page-preloader--active',
                soft && 'nx-page-preloader--soft',
                showSpinner && 'nx-page-preloader--spinner',
            )}
            aria-hidden={!active}
            aria-busy={showSpinner || undefined}
            role="presentation"
        >
            <div className="nx-page-preloader-bar" />
            {showSpinner ? (
                <div className="nx-page-preloader-body" aria-live="polite">
                    <div
                        className="nx-page-preloader-spinner"
                        role="status"
                        aria-label="Carregando"
                    />
                    <span className="nx-page-preloader-label">Carregando…</span>
                </div>
            ) : null}
        </div>
    );
    return fullScreen ? (active ? <div className="nx-auth-preloader">{preloader}</div> : null) : preloader;
}
